import * as React from 'react';
import LocationCommonWellItemViewState from '../store/schema/LocationCommonWellItemViewState';
import ReadWriteCommonWellItem from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWellItem';
import strings from 'owa-strings/owa-common-strings';
import { classNamesFunction } from '@uifabric/utilities';
import { ControlIcons } from 'owa-control-icons';
import { getStyles } from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWellItem.styles';
import { Icon } from 'office-ui-fabric-react/lib';
import { isEnhancedLocation, LocationPersonaControl } from 'owa-location-persona';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import {
    ReadWriteCommonWellItemStyles,
    ReadWriteCommonWellItemStyleProps,
    ReadWriteCommonWellItemProps,
} from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWellItem.types';
import {
    IContextualMenuItem,
    ContextualMenu,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/ContextualMenu';

let styles = require('./LocationCommonWellItem.scss');

const getClassNames = classNamesFunction<
    ReadWriteCommonWellItemStyleProps,
    ReadWriteCommonWellItemStyles
>();

@observer
export default class LocationCommonWellItem extends ReadWriteCommonWellItem<
    LocationCommonWellItemViewState,
    ReadWriteCommonWellItemProps<LocationCommonWellItemViewState>
> {
    protected getCustomizedClassName = (): {
        [key in keyof ReadWriteCommonWellItemStyles]: string
    } => {
        let { theme, isSelected, isSmallSize, maxItemWidth } = this.props;

        return getClassNames(getStyles, {
            isSmallSize: isSmallSize,
            isRegularSize: !isSmallSize,
            isSelected: isSelected,
            isValid: true,
            isExpanding: false,
            isExpandable: false,
            theme: theme,
            maxItemWidth: maxItemWidth,
        });
    };

    protected getPersonaControl = (): JSX.Element => {
        let { viewState } = this.props;
        let personaIcon = viewState.persona &&
            viewState.persona.personaBlob &&
            isEnhancedLocation(viewState.persona.postalAddress) && (
                <LocationPersonaControl
                    className={styles.locationPersona}
                    locationPersona={viewState.persona}
                    size={PersonaSize.size32}
                />
            );
        if (viewState.persona.personaType == 'Room') {
            personaIcon = <Icon iconName={ControlIcons.Room} className={styles.roomIcon} />;
        }

        return (
            <div className={this.classNames.personaInfoWrapper}>
                {personaIcon}
                <span className={this.classNames.wellItemText}>
                    {viewState.persona && viewState.persona.displayName}
                </span>
            </div>
        );
    };

    protected getLeadingElement = (): JSX.Element => {
        return null;
    };

    protected getDisplayTextFromItem = (item: LocationCommonWellItemViewState): string => {
        return null;
    };

    protected getCanDragItem = (item: LocationCommonWellItemViewState): boolean => {
        return false;
    };

    protected getContextMenu = (): JSX.Element => {
        return (
            this.props.viewState.isContextMenuOpen && (
                <ContextualMenu
                    items={this.createContextMenuItems()}
                    onDismiss={this.onDismissContextMenu}
                    target={this.personaSpan}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                />
            )
        );
    };

    private createContextMenuItems = (): IContextualMenuItem[] => {
        return [
            {
                key: 'remove',
                name: strings.readWriteRecipientMenu_Remove,
                onClick: this.removeItem,
            },
        ];
    };
}
